import { useEffect } from "react"
import { useLogin } from "../../hooks/useLogin"
import LoginForm from "../../components/login-form"
import FirstTimeLoginForm from "../../components/first-time-login-form"
import CustomerBookingList from "../../components/customer-booking-list"

export default function LoginModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const {
    login,
    loginUser,
    modalState,
    setModalState,
    changePassword,
  } = useLogin()

  useEffect(() => {
    if (!isOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = "hidden"
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose()
    }
    window.addEventListener("keydown", onKey)
    return () => {
      document.body.style.overflow = prev
      window.removeEventListener("keydown", onKey)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[200] flex items-end justify-center sm:items-center sm:p-4"
      role="presentation"
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/75 backdrop-blur-[3px]"
        aria-label="Close"
        onClick={onClose}
      />

      <div
        role="dialog"
        aria-modal="true"
        aria-label="Account"
        className={`relative z-[201] flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-2xl bg-white shadow-[0_25px_50px_-12px_rgba(0,0,0,0.35)] ring-1 ring-gray-900/10 sm:max-h-[88vh] sm:rounded-2xl ${
          loginUser ? "max-w-5xl" : "max-w-md"
        }`}
      >
        {!loginUser && modalState === "login" && (
          <LoginForm onClose={onClose} login={login} setModalState={setModalState} />
        )}
        {!loginUser && modalState === "changePassword" && (
          <FirstTimeLoginForm
            onClose={onClose}
            changePassword={changePassword}
            setModalState={setModalState}
          />
        )}
        {loginUser && <CustomerBookingList onClose={onClose} />}
      </div>
    </div>
  )
}
